import { TextField } from "@mui/material";
import React from "react";

const FilterInput = ({ label, name, value, onChange, type, style }) => {
  return (
    <TextField
      size="small"
      label={`Search By ${label}`}
      variant="outlined"
      style={{ margin: "5px", ...style }}
      type={type ? type : "text"}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export default FilterInput;
